import React, { Component } from 'react';
import axios from 'axios';
import '../../assets/styles/MostUsed/Icon.sass';
import IconExporter from './IconExporter.js';

class Icon extends Component {
  constructor(props) {
    super(props);
    this.setMagnitude = this.setMagnitude.bind(this);
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  buildStyles() {
    let backgroundColor = `#${this.props.backgroundColor}`;
    let backgroundImage = `url(${IconExporter[this.props.magnitude]}) no-repeat center`;

    return { background: `${backgroundColor} ${backgroundImage}` };
  }

  setMagnitude() {
    let magnitude = this.props.magnitude;
    let url = `${process.env.REACT_APP_API_URL}/magnitudes/${magnitude}`;

    axios.get(url).then(response => this.props.onIconClick(response.data));
  }

  render() {
    let magnitude = this.props.magnitude;

    return (
      <li className="Icon" style={ this.buildStyles() } onClick={ this.setMagnitude }>
        <span className="Icon__hover">{ this.capitalize(magnitude) }</span>
      </li>
    );
  }
}

export default Icon;
